import { Injectable } from '@angular/core';
import { LocalStorageService } from './local-storage.service';
import { SessionStorageService } from './../storage/session-storage.service';
// import { CaseSearchLookupDto } from './../../../core/domain/case/models/orderSearchDto';
// import { OrderCaseLookupDto } from './../../../core/domain/models/orderCaseLookupDto';

const CASE_SEARCH_LOOKUP = 'case_search_lookup';
const ORDER_CASE_LOOKUP = 'order_case_lookup';

//TODO: split the lookups

@Injectable({
    providedIn: 'root',
})
export class LookupStorageService {
    constructor(private localStorageService: LocalStorageService, private sessionStorageService: SessionStorageService) {}

    public clearLookupStorage(): void {
        // this.localStorageService.remove(CASE_SEARCH_LOOKUP);
        // this.localStorageService.remove(ORDER_CASE_LOOKUP);
    }

    // public saveCaseSearchLookup(value: any): void {
    //     this.localStorageService.remove(CASE_SEARCH_LOOKUP);
    //     this.localStorageService.set(CASE_SEARCH_LOOKUP, value);
    // }

    // public getCaseSearchLookup(): CaseSearchLookupDto {
    //     return this.localStorageService.get(CASE_SEARCH_LOOKUP);
    // }

    // public saveOrderCaseLookup(value: any): void {
    //     this.localStorageService.remove(ORDER_CASE_LOOKUP);
    //     this.localStorageService.set(ORDER_CASE_LOOKUP, value);
    // }

    // public getOrderCaseLookup(): OrderCaseLookupDto {
    //     return this.localStorageService.get(ORDER_CASE_LOOKUP);
    // }
}
